import { lazy } from 'react'

export const BehaviourChangesVariant1 = lazy(
  () => import('./BehaviourChangesVariant1'),
)
